// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1035G","name":"ConsentHeader_name__2VkG5","birthday":"ConsentHeader_birthday__3F9Pc","skeleton":"ConsentHeader_skeleton__2Uy3i"};